<template>
  <div class="pages">
    <!-- 联系客服 -->
    <el-popover
    placement="left"
    width="240"
    trigger="click"
    >
      <div class="kfshow" >
        <div class="service-title">
          <img v-if="isCN" src="/static/other/icon_js.png"/>
          <img v-if="!isCN" src="/static/home/skype.png"/>
          <span class="service-span">  {{ $t('main.onlineService') }}</span>
        </div>
        <div class="bgcolor">
          <div v-if="isCN"  v-for="(item, index) in contactList" :key="index" class="bgwhite">
            <el-card class="box-card" shadow="always">
              <div class="text item">
                <i class="el-icon-user"></i>
                {{item.name}}
              </div>
              <div class="text item">
                <i class="el-icon-mobile-phone"></i>
                {{ item.url }} (微信同号)
              </div>
            </el-card>
          </div>

          <div v-if="!isCN" v-for="(item, index) in contactList" :key="index" class="bgwhite">
            <a :href="'skype:' + item.url +'?chat'" target="_blank">
              <el-card style="text-align: center;" class="box-card" shadow="always">
                <div class="text item">
                  <img style="width:14px;" src="/static/home/skype.png"/>
                  {{item.name}}
                </div>
              </el-card>
            </a>
          </div>
        </div>
      </div>
    <div class="cus" slot="reference">
      <img src="/static/home/tools/kf-choose.png" class="rImg" />
    </div>
    </el-popover>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {
  getBlokcList
} from "@/api";

export default {
  data() {
    return {
      contactList:[]
    };
  },
  props: ["siteConfig", "isCN"],
  watch: {
    "$store.state.siteInfo": function() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getContact();
    },
    getContact(){
      var params = {
        "req": {
          "page": 1,
          "where": [
            {
              "condition": "2",
              "filed": "type",
              "expression": "="
            },
            {
              "condition": Cookies.get("siteInfo"),
              "filed": "site_id",
              "expression": "="
            },
            {
              "condition": "1",
              "filed": "is_show",
              "expression": "="
            }
          ],
          "limit": 20,
          "order": "orderby desc"
        }
      };
      getBlokcList(params).then(res => {
        if(res.rsp.code === 0) {
            //  this.bannerList = res.data.list;
            this.contactList = res.data.list;
        }
      });
    }
  }
};
</script>

<style scoped>
.rImg {
  width: 60px;
  height: 60px;
  margin-top: 10px;
}
.cus {
  position: relative;
  cursor: pointer;
}

.kfshow {
    background-color: #F0F0F0;
}
::v-deep .el-card {
  text-align: left;
}
::v-deep .el-card__body,
::v-deep .el-main {
  padding: 2px 10px;
}

.kfshow .service-title {
  display:flex;
  justify-content: center;
  vertical-align:center;
}
.kfshow .service-title img {
  height: 30px;
  vertical-align:bottom;
}
.kfshow .service-title .service-span {
  font-size: 1.1428rem;
  line-height: 30px;
  padding-left: 10px;
}

.bgcolor {
    background-color: #F0F0F0;
    padding: 2px;
}

.bgwhite{
     background-color: white;
    margin-top: 2px;
    padding: 4px;
    border-radius: 5px;
    color: #333333;
    text-align: center;
}
</style>
